import { isDefinedString } from "et3-type-guards";

import { apiCallChangeUserStatus } from "../../../api/user-api/api-call-change-user-status";
import i18n from "../../../constants/i18n";
import { TCorePage } from "../../../Types";
import getTBWStore from "../../developer-store/tbw-store";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import getUserAdvancedStore from ".";

const updateUserLocally = (userId: number, newStatus: string) => {
  if (isDefinedString(newStatus) && newStatus !== "ERROR") {
    if (getUserAdvancedStore().userData.has(userId)) {
      const oldUserData = getUserAdvancedStore().userData.get(userId);
      if (newStatus === "silent_banned") {
        const silentBannedUserData = Object.assign(oldUserData, {
          isSilentBanned: 1
        });
        getUserAdvancedStore().userData.set(userId, silentBannedUserData);
        return;
      }
      const newUserData = Object.assign(oldUserData, {
        status: newStatus
      });
      getUserAdvancedStore().userData.set(userId, newUserData);
    }
  }
};
const changeUserStatusOnDataBase = async ({
  userId,
  userUUID,
  selectedReasons,
  userStatus,
  pageName
}: {
  userId: number;
  userUUID: string;
  selectedReasons: number[];
  userStatus: string;
  pageName: TCorePage;
}) => {
  getCoreUIStore().setIsLoading("USER_ADVANCED", true);
  getUserAdvancedStore().setChangeStatusInput({
    label: "",
    value: ""
  });
  const temporaryBanDays = getTBWStore().temporaryBanDays.get();
  const TBW_ids = selectedReasons;
  const extraData = { TBW_ids, temporaryBanDays };
  const { status, code, data } = await apiCallChangeUserStatus({
    userUUID,
    userStatus: userStatus,
    pageName,
    extraData
  });
  getCoreUIStore().setIsLoading("USER_ADVANCED", false);
  if (status === "OK") {
    const newStatus = data;
    getCorePopUpStore().showSuccessMessage("USER_STATUS_CHANGED_SUCCESSFULLY");
    updateUserLocally(userId, newStatus);
    return newStatus;
  } else {
    getCorePopUpStore().showAlertMessage(code);
    return "ERROR";
  }
};
const changeUserStatus = async ({
  userId,
  userUUID,
  selectedReasons,
  showTBW,
  userStatus,
  userOldStatus,
  pageName
}: {
  userId: number;
  userUUID: string;
  selectedReasons: number[];
  userStatus: string;
  userOldStatus: string;
  showTBW: boolean;
  pageName: TCorePage;
}) => {
  if (showTBW) {
    if (userStatus === "banned" || userStatus === "temporary_banned") {
      await getTBWStore().showActionTBWPopUp({
        type: "ACTION_TBW",
        headerMessage: i18n.getWithExtraData(
          "SELECT_REASONS_OF_ACTION",
          userStatus
        ),
        actionName: userStatus,
        fromPage: "USER_ADVANCED",
        extraData: {
          userUUID,
          userID: userId,
          reportedUUID: "",
          reportedID: -1,
          reportID: -1,
          secondPartyID: -1
        },
        issueAudit: "",
        eventId: -1
      });
      if (
        userOldStatus === "deactivated" &&
        userStatus === "temporary_banned"
      ) {
        getCorePopUpStore().showHelperMessage("TB_DEACTIVATED_USER");
      }
      return;
    }
  }
  const newStatus = await changeUserStatusOnDataBase({
    userId,
    userUUID,
    selectedReasons,
    userStatus,
    pageName
  });
  return newStatus;
};
export default changeUserStatus;
